import { Col, Row } from "react-bootstrap";
import closeIcon from "../../assets/icons/x-circle.svg";
import React, { useState, useEffect } from "react";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const ConditionTypeSelection = ({ close, apply }) => {
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Workflow-Automation-Add-Edit").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const [selectedOption, setSelectedOption] = useState("");
  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const onApply = () => {
    apply(selectedOption);
    close(false);
  };

  return (
    <div className="workflo-and-or-popup">
      <div className="workflow-option p-5">
        <img
          src={closeIcon}
          className="close-icon"
          onClick={() => {
            close(false);
          }}
        />

        <Row>
          <Col>
            <div className="text-center">
              {/* Choose the behaviour of the condition on the following action */}
              {t(
                "Choose the behaviour of the condition on the following action",
              )}
            </div>
          </Col>
        </Row>

        <Row className="mt-4">
          <Col className="d-flex justify-content-center">
            <div className="option-card">
              <span>
                {/* This Condition */}
                {t("This Condition")}
              </span>
              <div className="mb-3 mt-1">
                <label class="custom-radio mt-3 d-flex justify-content-center">
                  <input
                    type="radio"
                    name="option"
                    value="AND"
                    onChange={handleOptionChange}
                    checked={selectedOption === "AND"}
                  />
                  <span class="radio-mark"></span>{" "}
                  <strong>
                    {/* AND */}
                    {t("AND")}
                  </strong>
                </label>
              </div>
              <span style={{ fontSize: "14px" }}>
                {/* previous condition(s) should be matched */}
                {t("previous condition(s) should be matched")}
              </span>
            </div>
          </Col>
          <Col className="d-flex justify-content-center">
            <div className="option-card">
              <span>
                {/* This Condition */}
                {t("This Condition")}
              </span>
              <div className="mb-4 mt-2">
                <label class="custom-radio mt-3 d-flex justify-content-center">
                  <input
                    type="radio"
                    name="option"
                    value="OR"
                    onChange={handleOptionChange}
                    checked={selectedOption === "OR"}
                  />
                  <span class="radio-mark"></span> <strong>OR</strong>
                </label>
              </div>
              <span style={{ fontSize: "14px" }}>
                {/* previous condition(s) should be matched */}
                {t("previous condition(s) should be matched")}
              </span>
            </div>
          </Col>
        </Row>

        <Row>
          <Col className="d-flex justify-content-center mt-5">
            <div
              className="apply-btn"
              onClick={() => {
                onApply();
              }}
            >
              {/* Apply */}
              {t("Apply ")}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ConditionTypeSelection;
